import { render, staticRenderFns } from "./BuySell.vue?vue&type=template&id=166f8add&scoped=true"
var script = {}
import style0 from "./BuySell.vue?vue&type=style&index=0&id=166f8add&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f8add",
  null
  
)

export default component.exports